import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AppUtils } from 'src/app/helpers/app.utils';
import { ContributorStripeAccountErrorModel } from '../../models/contributor.stripe.accout.error.model';
import { PhotographerProfileService } from '../../services/profile.service';


@Component({
    selector: 'app-stripe-account-error',
    templateUrl: './stripe.account.error.component.html',
})
export class StripeAccountErrorComponent implements OnInit {
    @Input() public id;
    model = new ContributorStripeAccountErrorModel();

    constructor(public activeModal: NgbActiveModal,
        private ngxSpinnerService: NgxSpinnerService,
        private toastr: ToastrService,
        private profileService: PhotographerProfileService) {

    }
    ngOnInit(): void {
        setTimeout(() => {
            this.getErrors();
        });
    }



    close(): void {
        this.activeModal.close();
    }

    getErrors() {
        this.ngxSpinnerService.show();
        this.profileService.getStripeAccountErrors(this.id).subscribe(
            res => {
                Object.assign(this.model, res);
                if (this.model.status === 4) {
                    this.close();
                    this.toastr.success('Verified successfully.');
                }
                if (this.model.status === 2) {
                    this.close();
                    this.toastr.warning('Pending for verification.');
                }
                this.ngxSpinnerService.hide();
            }, error => {
                this.ngxSpinnerService.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }
}
